import React, { PureComponent } from 'react';
import { string, bool, shape } from 'prop-types';
import { withEnvironmentData } from 'connectors';
import './Tile.scss';

class Tile extends PureComponent {
    static propTypes = {
        buttonText: string.isRequired,
        title: string.isRequired,
        image: string.isRequired,
        url: string.isRequired,
        env: shape({
            IS_DEV: bool,
        }).isRequired,
    };

    constructor(props = {}) {
        super(props);

        this.imgUrl = props.env.IS_DEV
            ? `//${this.props.image}`
            : this.props.image;
    }

    render() {
        const { buttonText, title, url } = this.props;

        return (
            <div className="tile">
                <a
                    className="tile__content"
                    href={url}
                    style={{ backgroundImage: `url("${this.imgUrl}")` }}
                >
                    <span className="tile__overlay">
                        <span className="tile__animate">
                            <span className="tile__txt tile__txt--title merchandising-tile-title">
                                {title}
                            </span>
                            <span className="tile__button button button--lowercase button--primary">
                                {buttonText}
                            </span>
                        </span>
                    </span>
                </a>
            </div>
        );
    }
}

export default withEnvironmentData(Tile);
